export default [
    {title: 'Animals'},
    {title: 'People'},
    {title: 'Fantasy'},
    {title: 'Dance'},
    {title: 'Music'},
    {title: 'Sports'},
    {title: 'Food'},
    {title: 'Fashion'}
];
